"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EuraOverlaySiderMenu = void 0;
const react_1 = __importDefault(require("react"));
const antd_1 = require("antd");
const react_router_dom_1 = require("react-router-dom");
require("../styles/eura-sider-menu.css");
const Icons_1 = require("./Icons");
/** Wrapperi AntD:n Menu-komponenttien ympärille.
 * Kuvaus propseista: https://ant.design/components/menu/#API
 */
const EuraOverlaySiderMenu = (props) => {
    const { mode, className } = props, rest = __rest(props, ["mode", "className"]);
    const classConstruct = ['eura-menu', className !== null && className !== void 0 ? className : ''];
    const euraMode = mode ? mode : 'inline';
    return (react_1.default.createElement(antd_1.Menu, Object.assign({ "aria-label": props.ariaLabel, mode: euraMode, className: classConstruct.join(' ') }, rest), props.children));
};
exports.EuraOverlaySiderMenu = EuraOverlaySiderMenu;
const __SubMenu = (props) => {
    const { className } = props, rest = __rest(props, ["className"]);
    const classConstruct = ['eura-submenu', className !== null && className !== void 0 ? className : ''];
    return (react_1.default.createElement(antd_1.Menu.SubMenu, Object.assign({ "aria-label": props.ariaLabel, className: classConstruct.join(' '), expandIcon: react_1.default.createElement(Icons_1.RightArrowIcon, null) }, rest), props.children));
};
const Divider = () => {
    return react_1.default.createElement("li", { className: 'ant-menu-item-divider', role: 'separator' });
};
const EuraNoncollapsibleSubMenu = (props) => {
    const { children, currentPageId, dataTestid, subitemTitles, titleLinkTo, titleText, clickable } = props;
    const selected = currentPageId ? subitemTitles.includes(currentPageId) : false;
    return (react_1.default.createElement("li", { className: `ant-menu-submenu ant-menu-submenu-inline${selected ? ' ant-menu-submenu-open ant-menu-submenu-selected' : ''}`, role: 'menuitem' },
        react_1.default.createElement("div", { className: `ant-menu-submenu-title ant-menu-submenu-title-custom ${selected && clickable ? ' ant-menu-item-selected' : ''}`, style: { paddingLeft: '24px' }, "data-testid": dataTestid }, selected && !clickable ? titleText : react_1.default.createElement(react_router_dom_1.Link, { to: titleLinkTo }, titleText)),
        selected && (react_1.default.createElement("ul", { className: 'ant-menu ant-menu-sub ant-menu-inline', role: 'menu' }, children))));
};
exports.EuraOverlaySiderMenu.Divider = Divider;
exports.EuraOverlaySiderMenu.Sub = EuraNoncollapsibleSubMenu;
exports.EuraOverlaySiderMenu.SubMenu = __SubMenu;
